import React, { useEffect, useState } from 'react';

import { HorizontalLine } from '@/components/elements';
import { LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import useHighlightLockboxStatusStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useHighlightLockboxStatus.store';

import { StatusCardWrapper } from './LockboxStatus.styles';
import LockboxStatusForm from './LockboxStatusForm';
import LockboxStatusHeader from './LockboxStatusHeader';

const HIGHLIGHT_DURATION = 3000;

const LockboxStatusCard = () => {
  const { highlightStatus, reset } = useHighlightLockboxStatusStore();
  const [localHighlight, setLocalHighlight] = useState<LockboxStatus | undefined>(undefined);

  // Pick up the highlight from the store on mount/change and manage locally
  useEffect(() => {
    if (highlightStatus) {
      setLocalHighlight(highlightStatus);
      reset(); // Clear the store immediately so it doesn't persist across re-renders
    }
  }, [highlightStatus, reset]);

  // Start the 3s countdown only when localHighlight is set
  useEffect(() => {
    if (!localHighlight) return;

    const timer = setTimeout(() => {
      setLocalHighlight(undefined);
    }, HIGHLIGHT_DURATION);

    return () => {
      clearTimeout(timer);
    };
  }, [localHighlight]);

  return (
    <StatusCardWrapper
      data-testid="lockbox-status-card"
      margin={{ top: 'spacing8' }}
      background="canvas"
      round="container1Round"
      pad={{ top: 'spacing12', horizontal: 'spacing24', bottom: 'spacing16' }}
      isHighlight={!!localHighlight}
      status={localHighlight}
    >
      <LockboxStatusHeader />
      <HorizontalLine margin={{ vertical: 'spacing12' }} />
      <LockboxStatusForm />
    </StatusCardWrapper>
  );
};

export default LockboxStatusCard;
